export enum UserRole {
  Patient = 'PATIENT',
}
